import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'separarLetra',
    standalone: false
})
export class SepararLetraPipe implements PipeTransform {

  transform(value: string): any {
    return value.split(/(?=[A-Z])/).toString().replace(',', ' ');
  }

}
